export default __webpack_public_path__ + "static/media/team-member-placeholder.959c6282.webp";